<template>
    <main-content>
        <kt-panel>
            <kt-panel-body>
                <ul class="nav nav-pills">
                    <li v-if="stakeholder_type == relatedMerchantType.GATEWAY" class="nav-item">
                        <router-link :class="['nav-link', $route.name == 'stakeholders_update' ? 'active' : '']" :to="`/stakeholders/update/${$route.params.hashid}`">{{ $t('stakeholders.label.info') }}</router-link>
                    </li>
                    <li v-else-if="stakeholder_type == relatedMerchantType.WALLET" class="nav-item">
                        <router-link :class="['nav-link', $route.name == 'stakeholders_update_wallet_type' ? 'active' : '']" :to="`/stakeholders/update-wallet-type/${$route.params.hashid}`">{{ $t('stakeholders.label.info') }}</router-link>
                    </li>
                    <li v-else-if="stakeholder_type == relatedMerchantType.PSP" class="nav-item">
                        <router-link :class="['nav-link', $route.name == 'stakeholders_update_psp_type' ? 'active' : '']" :to="`/stakeholders/update-psp-type/${$route.params.hashid}`">{{ $t('stakeholders.label.info') }}</router-link>
                    </li>
                    <li class="nav-item" v-if="$can('manage-stakeholder', 'user')">
                        <router-link :class="['nav-link', $route.name == 'stakeholders_change_status' ? 'active' : '']" :to="{name: 'stakeholders_change_status', params: { hashid: $route.params.hashid, stakeholder_type: stakeholder_type } }">{{ $t('stakeholders.label.change_status') }}</router-link>
                    </li>
                    <li class="nav-item" v-else-if="stakeholder_type == relatedMerchantType.GATEWAY">
                        <router-link :class="['nav-link', $route.name == 'stakeholders_shops_info' ? 'active' : '']" :to="{name: 'stakeholders_shops_info', params: { hashid: $route.params.hashid, stakeholder_type: stakeholder_type } }">{{ $t('stakeholders.label.shop_attachment_info') }}</router-link>
                    </li>
                </ul>
                <slot></slot>
            </kt-panel-body>
        </kt-panel>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content.vue';
import { relatedMerchantType } from '@/constants/related_merchant_type';

export default {
    components: {
        mainContent,
    },
    data() {
        return {
            relatedMerchantType: relatedMerchantType,
        }
    },
    props: {
        stakeholder_type: {
            type: Number,
            required: true,
        },
    },
}
</script>
